<template>
  <div>
    <router-link
      class="profile-nav-menu d-flex justify-content-between text-decoration-none"
      :to="routePath"
      @click.native="scrollToTop"
    >
      <span>{{ linkName }}</span>
      <i class="text-right fa fa-caret-right"></i>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    routePath: {
      type: [String, Object],
      default: "",
    },
    linkName: {
      type: String,
      default: "",
    },
  },
  methods:{
    scrollToTop() {
      window.scrollTo(0,0);
    },
  }
};
</script>

<style>
.profile-nav-menu i {
  line-height: 21px;
}
.profile-nav-menu {
  padding: 12px 12px;
  border-bottom: 1px solid #f2f2f2;
}
.profile-nav-menu.active {
  color: #fff !important;
  background: var(--primary);
}
</style>
